__turbopack_context__.v({
  "button": "style-module-scss-module__kN4EjW__button",
  "fit": "style-module-scss-module__kN4EjW__fit",
  "loaderCon": "style-module-scss-module__kN4EjW__loaderCon",
  "midnight": "style-module-scss-module__kN4EjW__midnight",
  "prefixIcon": "style-module-scss-module__kN4EjW__prefixIcon",
  "small": "style-module-scss-module__kN4EjW__small",
  "spin": "style-module-scss-module__kN4EjW__spin",
  "suffixIcon": "style-module-scss-module__kN4EjW__suffixIcon",
  "tang-blue": "style-module-scss-module__kN4EjW__tang-blue",
  "text": "style-module-scss-module__kN4EjW__text",
  "white": "style-module-scss-module__kN4EjW__white",
});
